import { render, staticRenderFns } from "./RemoveConfirmation.vue?vue&type=template&id=4904af48&scoped=true&"
import script from "./RemoveConfirmation.vue?vue&type=script&lang=js&"
export * from "./RemoveConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./RemoveConfirmation.vue?vue&type=style&index=0&id=4904af48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4904af48",
  null
  
)

export default component.exports